import { shouldReduceCacheTimeForDevEnv } from '../app/utils';
import { hasAcceptedCookie } from '../app/components/CookieAccept/utils';

const USER_CONTEXT_STORAGE_VERSION = '1';
export const GENERAL_MODULE_NAME = 'user';
export const USER_CONTEXT_URL = '/context/usercontextjson';
export const USER_CONTEXT_CACHE_TIMEOUT = shouldReduceCacheTimeForDevEnv() ? 60000 : 1800000;
export const USER_CONTEXT_PERSIST_TIME_KEY = `user_v_${USER_CONTEXT_STORAGE_VERSION}`;
export const LIST_PAGE_TYPE_ID = 99;

export const userContextDefaultState = {
	isInitialized: false,
	isPending: true,
	id: undefined,
	isAuthenticated: false,
	canViewProfile: false,
	email: undefined,
	formattedName: undefined,
	initials: undefined,
	customerName: '',
	activeLanguageId: undefined,
	organizationTypeId: undefined,
	organizationName: undefined,
	avatar: {
		hasPhoto: false,
		photoUrl: undefined,
	},
	hasAcceptedCookie: hasAcceptedCookie(),
};
export const PROFILE_URL = '/user/profile';
export const LOGIN_URL = '/user/login';
